import reportsConfig from '~/constants/data-reports/synthetic-graphite'

const syntheticGraphiteData = {
  hero: reportsConfig.hero,
  descriptions: [
    'The flake and synthetic graphite to anode supply chains are among the most fragmented of all lithium ion battery raw materials.',
    'Benchmark pieces these fragments together, building relationships and collecting data globally, be it from Heilongjiang, China, or Minas Gerais in Brazil.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1719430762/assets/market/synthetic-graphite/syntetic-graphite-1_ihzh2p.jpg',
  brochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Synthetic-Graphite-Price-Assessment-Methodology.pdf',
    EnvKey: 'syntheticGraphitePriceAssessmentsMethodologyId',
  },
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  indexTab: true,
  customisationToolTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'purities', 'priceTypes'],
}
export default syntheticGraphiteData
